import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { WHATSAPP_LINK, IMG } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const Quality = () => {
  const { t } = useLang();
  const q = t.quality;
  return (
    <section id="quality" data-testid="quality-section" className="bg-forest2 py-24 md:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-14 px-5 md:px-10 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <p className="overline text-gold">{q.overline}</p>
          <div className="mb-6 mt-3"><span className="gold-rule block" /></div>
          <h2 className="font-serif font-light text-cream text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
            {q.title}
          </h2>
          <p className="mt-6 max-w-lg text-cream/70 leading-relaxed">{q.text}</p>

          <ul className="mt-9 space-y-4">
            {q.specs.map((s, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <li data-testid={`quality-spec-${i}`} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gold text-gold">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  <span className="text-cream/85">{s}</span>
                </li>
              </Reveal>
            ))}
          </ul>

          <a
            data-testid="quality-cta"
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center bg-gold hover:bg-golddark text-white overline px-8 py-4 transition-colors duration-300"
          >
            {q.cta}
          </a>
        </Reveal>

        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="spotlight overflow-hidden rounded-t-[200px]"
        >
          <img
            src={IMG.flower}
            alt="Vanilla orchid in bloom"
            className="h-[460px] w-full object-cover md:h-[600px]"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Quality;
